import { request } from '../../Common/api/client';

/**
 * POST /api/cp/login - 가맹점 로그인 (앱도 동일 API 사용)
 * Body: { cpId, password }
 * 응답: cp(id, cp_id, name, status), must_change_password
 */
export async function cpLogin({ cpId, password }) {
  return request({
    method: 'POST',
    url: '/api/cp/login',
    data: { cpId, password },
  });
}

/**
 * POST /api/cp/logout - 가맹점(CP) 세션 종료, 세션 쿠키 삭제 (앱도 동일 API 사용)
 */
export async function cpLogout() {
  return request({ method: 'POST', url: '/api/cp/logout' });
}

/**
 * POST /api/cp/terminal/login - 영업자 로그인
 * Body: { terminalId, password }
 * 응답: terminal(id, terminalId, name 등)
 */
export async function terminalLogin({ terminalId, password }) {
  return request({
    method: 'POST',
    url: '/api/cp/terminal/login',
    data: { terminalId, password },
  });
}

/**
 * POST /api/cp/terminal/logout - 영업자 세션 종료
 */
export async function terminalLogout() {
  return request({ method: 'POST', url: '/api/cp/terminal/logout' });
}

/**
 * POST /api/cp/terminal/change-password - 영업자 본인 비밀번호 변경 (세션 필요)
 * Body: { currentPassword, newPassword }
 */
export async function terminalSelfChangePassword({ currentPassword, newPassword }) {
  return request({
    method: 'POST',
    url: '/api/cp/terminal/change-password',
    data: { currentPassword, newPassword },
  });
}

/**
 * GET /api/terminal/customer - 로그인된 영업자 기준 거래처(약국) 목록
 * Query: q, status, page, limit
 */
export async function getTerminalCustomerList(params = {}) {
  return request({ method: 'GET', url: '/api/terminal/customer', params });
}

/**
 * GET /api/terminal/pharmacy - 약국 마스터 검색 (등록용)
 * Query: q, status, page, limit
 */
export async function getTerminalPharmacySearch(params = {}) {
  return request({ method: 'GET', url: '/api/terminal/pharmacy', params });
}

/**
 * GET /api/terminal/pharmacy - 로그인 terminal에게 매칭된 약국 검색
 * Query: q, page, limit
 */
export async function getMappedTerminalPharmacies(params = {}) {
  return request({ method: 'GET', url: '/api/terminal/pharmacy', params });
}

/**
 * POST /api/terminal/payment/manual - 매핑 기반 수기결제
 * customerMapId는 현재 로그인 terminal 소유 매핑이어야 한다.
 */
export async function submitMappedTerminalPayment(payload) {
  return request({
    method: 'POST',
    url: '/api/terminal/payment/manual',
    data: payload,
  });
}
